import { LOCATION_CHANGE } from 'shared/store/modules/router/actions';
import { handleActions } from 'redux-actions';
import moment from 'moment';

import {
  clearPreflight,
  createFromFilters,
  createRemaining,
  createWithCustomers,
  deleteCustomerFromBilling,
  deleteProjectFromBilling,
  deleteAllCustomersFromBilling,
  deleteAllCustomersFromBillingPreflight,
  deleteInvoices,
  fetchingInvoices,
  finalizeInvoices,
  generateInvoicesStatusExport,
  getBilling,
  getBillingDates,
  getEstimate,
  invoicesBillingPreflightCheck,
  invoicesError,
  invoicesGenerateInvoices,
  invoicesGeneratePreflightExport,
  invoicesGeneratingExportStart,
  invoicesActivityStart,
  invoicesActivityEnd,
  isGettingBillingDates
} from 'shared/store/modules/invoices/actions';

const defaultState = {
  isFetching: false,
  isInvoicingBusy: false,
  error: null,
  data: {
    alerts: [],
    invoiceGenerationDetails: []
  },
  recentlyDeleted: [],
  preflightExportData: null,
  invoiceStatusExportData: null,
  billingDates: null,
  invoicingTimestamp: null
};

const getCurrentTimestamp = () => {
  const currentTime = moment().format('MM/DD/YYYY HH:mm:ss');
  const timeZoneAbbreviation = new Date()
    .toLocaleString('en-US', {
      timeZoneName: 'short'
    })
    .split(' ')
    .pop();
  const timestamp = currentTime + ' ' + timeZoneAbbreviation;
  return timestamp;
};

// Reducer
// TODO: use combineActions

export const reducer = handleActions(
  {
    [LOCATION_CHANGE]: (_state, { payload }) => ({
      ..._state,
      isFetching: true,
      isComplete: false,
      invoiceStatusExportData: null,
      preflightExportData: null,
      data: defaultState.data
    }),

    [fetchingInvoices]: (_state, { payload }) => ({
      ..._state,
      isFetching: false,
      error: null
    }),

    [isGettingBillingDates]: (_state, { payload }) => ({
      ..._state,
      isFetchingBillingDates: true
    }),

    [getBillingDates]: (_state, { payload }) => ({
      ..._state,
      billingDates: payload,
      isFetchingBillingDates: false
    }),

    [invoicesGeneratingExportStart]: (_state, { payload }) => ({
      ..._state,
      isFetching: true,
      preflightExportData: null,
      invoiceStatusExportData: null
    }),

    [invoicesActivityStart]: (_state, { payload }) => ({
      ..._state,
      isComplete: false,
      preflightCheck: null,
      error: null,
      isInvoicingBusy: true
    }),

    [invoicesError]: (_state, { payload }) => ({
      ..._state,
      error: payload.response,
      isFetching: false,
      isComplete: true
    }),

    [invoicesBillingPreflightCheck]: (_state, { payload }) => ({
      ..._state,
      preflightCheck: payload,
      isFetching: false
    }),

    [invoicesGeneratePreflightExport]: (_state, { payload }) => ({
      ..._state,
      preflightCheck: null,
      preflightExportData: payload,
      isFetching: false
    }),

    [generateInvoicesStatusExport]: (_state, { payload }) => ({
      ..._state,
      invoiceStatusExportData: payload,
      isFetching: false,
      error: null
    }),

    [invoicesGenerateInvoices]: (_state, { payload }, statusMessage) => {
      const timestamp = getCurrentTimestamp();

      return {
        ..._state,
        data: payload,
        isFetching: false,
        statusMessage,
        invoicingTimestamp: timestamp
      };
    },

    [invoicesActivityEnd]: (_state, { payload }) => ({
      ..._state,
      data: payload,
      isFetching: false,
      isComplete: true,
      isDeleting: false,
      isInvoicingBusy: false
    }),

    [deleteInvoices]: (_state, { payload }, statusMessage) => {
      const timestamp = getCurrentTimestamp();

      return {
        ..._state,
        data: payload,
        isFetching: false,
        statusMessage,
        invoicingTimestamp: timestamp
      };
    },

    [finalizeInvoices]: (_state, { payload }, statusMessage) => {
      const timestamp = getCurrentTimestamp();

      return {
        ..._state,
        data: payload,
        isFetching: false,
        statusMessage,
        invoicingTimestamp: timestamp
      };
    },

    [getEstimate]: (_state, { payload }) => ({
      ..._state,
      remainingCustomersCount: payload.count,
      isFetching: false
    }),

    [createFromFilters]: (_state, { payload }) => ({
      ..._state,
      newBilling: payload,
      isFetching: false
    }),

    [createWithCustomers]: (_state, { payload }) => ({
      ..._state,
      newBilling: payload,
      isFetching: false
    }),

    [createRemaining]: (_state, { payload }) => ({
      ..._state,
      newBilling: payload,
      isFetching: false
    }),

    [getBilling]: (_state, { payload }) => ({
      ..._state,
      billing: payload,
      isFetching: false
    }),

    [clearPreflight]: (_state, { payload }) => ({
      ..._state,
      preflightCheck: null
    }),

    [deleteCustomerFromBilling]: (_state, { payload }) => ({
      ..._state,
      data: {
        ..._state.data,
        invoiceGenerationDetails: _state.data.invoiceGenerationDetails.filter(
          i => i.billingCustomerDetailId !== payload
        )
      }
    }),

    [deleteProjectFromBilling]: (_state, { payload }) => {
      const newInvoiceDetails = _state.data.invoiceGenerationDetails.filter(i => i.billingCustomerDetailId !== payload);
      return {
        ..._state,
        data: {
          ..._state.data,
          invoiceGenerationDetails: newInvoiceDetails
        }
      };
    },

    [deleteAllCustomersFromBilling]: (_state, { payload }) => ({
      ..._state,
      recentlyDeleted: [..._state.recentlyDeleted, payload],
      isFetching: false
    }),

    [deleteAllCustomersFromBillingPreflight]: (_state, { payload }) => ({
      ..._state,
      preflightCheck: payload,
      isFetching: false
    })
  },

  defaultState
);
